import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Router from './routes/Router';
import store from './redux/store';
import theme from './utils/muiTheme';

const App: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
  </Provider>
);

export default App;
